/**
 * Componente de diseño (Layout) para el panel de administración.
 * Proporciona una estructura común con barra lateral (Sidebar) y encabezado con migas de pan (Breadcrumbs).
 */

import React from "react";
import AdminSidebar from "./AdminSidebar";
import "../../assets/css/DashboardAdmin.css";

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children - Contenido principal de la vista.
 * @param {string|React.ReactNode} props.breadcrumb - Ruta de navegación para mostrar en el encabezado.
 * @param {string} props.title - Título de la página actual.
 */
const AdminLayout = ({ children, breadcrumb, title }) => {
    // Estado para controlar la apertura de la barra lateral en dispositivos móviles
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className="admin-layout">
            {/* Fondo oscuro cuando el sidebar móvil está activo */}
            <div className={`sidebar-backdrop ${isSidebarOpen ? 'show' : ''}`} onClick={() => setIsSidebarOpen(false)}></div>

            <AdminSidebar isOpen={isSidebarOpen} toggle={toggleSidebar} />

            <main className="admin-main">
                <header className="admin-header">
                    <div className="admin-breadcrumb">{breadcrumb}</div>
                    <div className="d-flex align-items-center gap-3 w-100 justify-content-between">
                        <div className="d-flex align-items-center">
                            <button className="mobile-nav-toggle d-md-none" onClick={toggleSidebar}>
                                <i className="bi bi-list"></i>
                            </button>
                            <h2 className="admin-title">{title}</h2>
                        </div>
                    </div>
                </header>

                <div className="admin-content-container">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default AdminLayout;
